import { render, staticRenderFns } from "./verification-code.vue?vue&type=template&id=645530a2&scoped=true"
import script from "./verification-code.vue?vue&type=script&lang=js"
export * from "./verification-code.vue?vue&type=script&lang=js"
import style0 from "./verification-code.vue?vue&type=style&index=0&id=645530a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645530a2",
  null
  
)

export default component.exports